<template>
  <qc-dialog type="custom" :show.sync="innerShow" :title="$t('core.file_preview')" :closeTriggers="['esc']"
    :width="400" :default-cancel="false">
    {{$t('core.edit_exit_tips')}}

    <div slot="button">
      <qc-button type="default" class="mr-10" @click="saveAndExist">{{$t('core.save')}}
      </qc-button>
      <qc-button type="weak" class="mr-10" @click="unsaveAndExit">{{$t('core.noSave')}}</qc-button>
      <qc-button type="weak" @click="onCancel" :title="$t('core.cancel')">{{$t('core.cancel')}}</qc-button>
    </div>
  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  methods: {
    saveAndExist() {
      this.$emit('save');
      this.closeDialog();
    },
    unsaveAndExit() {
      this.$emit('unsave');
      this.closeDialog();
    },
    onCancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },

};
</script>

<style>
</style>
